import { formatCurrency } from "~/lib/format";
import type { YearSummary } from "~/types/financials";

interface BalanceSheetTableProps {
	years: YearSummary[];
}

const ROWS: { label: string; key: keyof YearSummary; bold?: boolean }[] = [
	{ label: "Stálá aktiva", key: "fixedAssets" },
	{ label: "Oběžná aktiva", key: "currentAssets" },
	{ label: "Celková aktiva", key: "totalAssets", bold: true },
	{ label: "Vlastní kapitál", key: "equity" },
	{ label: "Dlouhodobé závazky", key: "longTermLiabilities" },
	{ label: "Krátkodobé závazky", key: "currentLiabilities" },
	{ label: "Pasiva celkem", key: "totalLiabilities", bold: true },
];

export function BalanceSheetTable({ years }: BalanceSheetTableProps) {
	if (years.length === 0) return null;

	return (
		<div className="card-surface rounded-xl p-6">
			<h3 className="text-lg font-semibold mb-4">Rozvaha</h3>
			<div className="overflow-x-auto">
				<table className="w-full text-sm">
					<thead>
						<tr className="border-b">
							<th className="text-left py-2 pr-4 font-medium">Položka</th>
							{years.map((y) => (
								<th key={y.year} className="text-right py-2 px-2 font-medium tabular-nums">
									{y.year}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{ROWS.map((row) => (
							<tr key={row.key} className="border-b border-gray-100">
								<td className={`py-2 pr-4 ${row.bold ? "font-semibold" : "text-muted-foreground"}`}>
									{row.label}
								</td>
								{years.map((y) => (
									<td
										key={y.year}
										className={`text-right py-2 px-2 font-mono tabular-nums ${row.bold ? "font-semibold" : ""}`}
									>
										{formatCurrency(y[row.key] as number | null)}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
